globalThis.Store = class Store {
  constructor() {
    globalThis.STORE = this;
    this.loadSaves();
    this.loadProfile();
    this.loadProp("cameralock", false);
    this.loadProp("debug", false);
  }

  remove() {
    delete globalThis.STORE;
  }

  deleteWorld(name) {
    delete this.saves[name];
    this.saveProp("saves");
    dispatchEvent(new CustomEvent("store", { detail: "saves" }));
  }

  saveWorld() {
    if (!globalThis.GAME.id) return;
    this.saveWorldAs(globalThis.GAME.id);
  }

  saveWorldAs(name) {
    this.saves[name] = new WorldDocument(globalThis.WORLD.toBase64());
    this.saves[name].name = name;
    this.saveProp("saves");
    dispatchEvent(new CustomEvent("store", { detail: "saves" }));
  }

  loadWorldFromSave(name) {
    if (!this.saves[name]) return;
    globalThis.CLIENT.loadWorld(this.saves[name].data);
  }

  setProp(detail, value) {
    this[detail] = value;
    this.saveProp(detail);
    dispatchEvent(new CustomEvent("store", { detail }));
  }

  saveProp(prop) {
    localStorage.setItem(prop, JSON.stringify(this[prop]));
  }

  loadProp(detail, fallback = null) {
    const data = localStorage.getItem(detail);
    if (data == null) {
      this[detail] = fallback;
      dispatchEvent(new CustomEvent("store", { detail }));
      return this[detail];
    }
    try {
      const object = JSON.parse(data);
      this[detail] = object;
      dispatchEvent(new CustomEvent("store", { detail }));
      return this[detail];
    } catch (error) {
      console.error(error);
      localStorage.removeItem(detail);
    }
  }

  loadSaves() {
    this.loadProp("saves", {});
    this.saves = Object.assign({ Tutorial: null }, this.saves);
    this.saves.Tutorial = new WorldDocument(globalThis.TUTORIAL);
    for (const [key, save] of Object.entries(this.saves)) {
      this.saves[key] = new WorldDocument(save);
      this.saves[key].name = key;
    }
    this.saveProp("saves");
  }

  loadProfile() {
    this.loadProp("profile", new Profile());
    this.profile = new Profile(this.profile);
    this.saveProp("profile");
  }
};
